const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Convert backend file paths to accessible URLs
 * @param {string} url - File path from backend (e.g., /uploads/images/file.png)
 * @returns {string} - Full URL to access the file via API
 */
export const getFileUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  if (url.startsWith('/uploads/')) {
    return `${BACKEND_URL}/api/files/${url.replace('/uploads/', '')}`;
  }
  return `${BACKEND_URL}${url}`;
};
